export default __webpack_public_path__ + "static/media/mencloth.5f73b508.svg";